__turbopack_context__.v({
  "avatar": "ghost-module__w4x5wG__avatar",
  "bar": "ghost-module__w4x5wG__bar",
  "block": "ghost-module__w4x5wG__block",
  "chip": "ghost-module__w4x5wG__chip",
  "dark": "ghost-module__w4x5wG__dark",
  "ghostSheen": "ghost-module__w4x5wG__ghostSheen",
  "row": "ghost-module__w4x5wG__row",
  "rowDark": "ghost-module__w4x5wG__rowDark",
  "rowTop": "ghost-module__w4x5wG__rowTop",
  "rowTopDark": "ghost-module__w4x5wG__rowTopDark",
});
